module.exports = __webpack_public_path__ + "yousport_icon.embedded.svg?e4c041d1a093427aceb1e749ba1e4895";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/yousport_icon.embedded.svg
// module id = 1269
// module chunks = 15